import { IS_FIREFOX } from 'shared/user-agent.ts'
import type { NodeFieldFlags } from 'webgl-video-editor'

export * from './public-constants.ts'

export const MOBILE_MAX_WIDTH = 640

export const SourceNodeState = {
  waiting: 0,
  sequenced: 1,
  playing: 2,
  paused: 3,
  ended: 4,
  error: 5,
} as const
export type SourceNodeState = (typeof SourceNodeState)[keyof typeof SourceNodeState]

export const AssetBin = {
  video: 'assets-video',
  audio: 'assets-audio',
  fonts: 'assets-fonts',
  filters: 'assets-filters',
} as const
export type AssetBin = (typeof AssetBin)[keyof typeof AssetBin] | null

export const VIDEO_PREPLAY_TIME_S = 2
export const MEDIA_SYNC_INTERVAL_MS = 500
export const MEDIA_SYNC_TOLERANCE_S = 0.3

export const ASSET_URL_REFRESH_TIMEOUT_MS = 3000

export const VIDEO_DECODER_HW_ACCEL_PREF = IS_FIREFOX ? 'prefer-software' : 'no-preference'

export const DEFAULT_FRAMERATE = 24
export const DEFAULT_RESOLUTION = { width: 1920, height: 1080 }
export const ASSET_TYPE_PREFIX = 'asset:'

export const TIMELINE_ID = 'timeline'

export const PIXI_LUT_UPLOADER_ID = 'webgl-video-editor:lut'
export const PIXI_HALD_LUT_UPLOADER_ID = 'webgl-video-editor:hald-lut'

/* eslint-disable @typescript-eslint/no-magic-numbers -- enum */
const Readonly = 1 << 1
export const NODE_FIELD_FLAGS: NodeFieldFlags = {
  ReactiveProp: 1 << 0,
  Readonly,
  Node: 1 << 2,
  NodeArray: 1 << 3,
  Asset: 1 << 4,
  Gap: 1 << 5,
  Constant: (1 << 6) | Readonly,
  Animatable: 1 << 7,
  Color: 1 << 8,
  TransformProp: 1 << 9,
  TextStyleProp: 1 << 10,
}
/* eslint-enable @typescript-eslint/no-magic-numbers */

export const CLIP_COLORS = [
  '#e83757', // red-dark
  '#ff5372', // red
  '#ff7a92', // red-light
  '#a06efb', // purple
  '#ac7dff', // purple-light
  '#03ad70', // green
  '#1ed291', // green-light
]

export const FONT_FAMILIES = ['Arial', 'Helvetica', 'Times New Roman', 'Georgia', 'Courier New']
export const DEFAULT_FONT_FAMILY = FONT_FAMILIES[0]
export const DEFAULT_FILL_COLOR = '#ffffff'
export const FONT_WEIGHT_NORMAL = 400
export const FONT_WEIGHT_BOLD = 700

export const FIXED_AV_PAIRS = true as boolean
